import React, { Component } from "react";
import { Message } from "semantic-ui-react";
import axios from "axios";
import {Menu,Segment,Sidebar} from "semantic-ui-react";
import Srsichart18dec from "./Srsichart18dec";
import pagecontent from "../Helpers/HDContent";
import AboutModal from "../../GeoportalModal";
import { library } from "@fortawesome/fontawesome-svg-core";
import {faLayerGroup,faWindowClose,faChartBar,faAngleDoubleLeft,faAngleDoubleRight} from "@fortawesome/free-solid-svg-icons";
import TreeNode from "./TreeNodeV2";
import MapView from "./MapViewV2";
import Chart from "../../LineChart";

import { FadeLoader } from "react-spinners";
import menus from "../Helpers/menus";
import file_ext from "../Helpers/file-tails";
import domain from "../../domain";
import { Rnd } from "react-rnd";
import colors from "../../colors";
library.add(faLayerGroup,faWindowClose,faChartBar,faAngleDoubleLeft,faAngleDoubleRight);
var moment = require("moment");
function removeDuplicates(data) {
return [...new Set(data)];
}
let numClick = 0;
//console.log(window.innerHeight);
//============================================for graph values CATEGORIES=======================================================//
let categories = [
"Normal/Above Normal", "Mildly Dry", "Moderately Dry",
"Severly Dry","Extremely Dry"];
let categories_sgwi = [
"Normal/Above Normal","Slight Fall",
"Moderately Fall", "Severe Fall","Extreme Fall"];
let categories_srsi = [
"Normal/Above Normal","Slight Fall","Moderately Fall",
"Severe Fall","Extreme Fall"];
let categories_swsi_basin = [
"Normal/Above Normal","Mildly Dry","Moderately Dry",
"Severly Dry", "Extremely Dry"];
let categories_swsi_state = [
    "Normal/Above Normal","Mildly Dry","Moderately Dry",
    "Severly Dry", "Extremely Dry"];
let categories_chdi = [
"Normal/Above Normal", "Slight Fall","Moderately Fall",
"Severe Fall","Extreme Fall"];
class MapContainer extends Component {
constructor(props) {
super(props);
this.state = {
          //width: 420,
         // height: 350,
         width: Math.min(800, window.innerWidth * 0.9), // Adjust width for small screens
     height:Math.min(450, window.innerheight * 0.9),
     
          x: (window.innerWidth-270-800)/2,
          y: window.innerHeight - 460,
          nodata: false,
          selectedMenu: null,
          tabs: menus.mapSideBar,
          clickcount: 0,
          modal: true,
          indiaboundary: null,
          legendVisible: true,
          latlng:{ lat: null, lng: null },
          pointInfo: null,
          legend: null,
          selectedLayer: {},
          visible: true,
          showInfo: false,
          date: "",
//popup: {id: "", name: null, storage: null, index: null, status: null, position: null},original
popup: {id: "", name: null, basin:null, index: null, day: null,month:null,year:null, position: null},

          layerExist: true,
          wms_url_base_layers: `${domain.Geoserver}geoserver/base-layers/wms`,
          wms_url_default: `${domain.Geoserver}geoserver/surface-runoff-index-30-day-cumulative/wms`,
          india_states_boundary: null,
          visibleGraphPanel: false,
          visibleGraphPanel_pie: false,
          availableDates: [],
          selectedNodeStaus: {},
          slideTracker: -1,
          rchartData: null,
          chartData: null,
          onClickDetails: {},
          stateInfo: null,
          chartloading: false,
          datesloading: false,
          stateselected: "#",
          districtselected: "#",
          mandalselected: "#",
          stateBoundary: null,
          indiastates: null,
          indiadistricts: null,
          indiamandals: null,
          indiabasins:null,
          indiareservoirs:null,
          sri_stats: null,
          pie_categories: null,
          SRSIPoint: null,
          srsibasinboundary: null,
          srsireservoirboundary: null,
          swsibasinboundary: null,
          swsisubbasinboundary: null,
          technicalnoteenable: false,
          disclaimerenable: false,
//====================================Newly created functions for SWSI Basin and Subbasin AND SRSI Basin and Reservoirs==================================================
            srsi_chart:[],
            indiaHDBasins:null,
            indiaHDReservoirs:null,
            indiaSWSIBasinnames:null,
            indiaSWSISubbasinnames:null,

            indiaHDBasinsselected:"#",
            indiaHDReservoirsselected:"#",
            indiaSWSIBasinselected:"#",
            indiaSWSISubbasinselected:"#",
//================================================================================================COMMENT END FOR SRSI AND SWSI==========================================
};
this.makeChartDataAvailableDays = this.makeChartDataAvailableDays.bind(
this
);
}

showPointInfo = () => {this.setState({showInfo: !this.state.showInfo})
}
displayLegend = () => {this.setState({ legendVisible: !this.state.legendVisible });
};
setStateValue = (value) => {
//if (value !== "#") {
this.setState({
        stateselected: value,
        districtselected: "#",
        mandalselected: "#",
        indiadistricts: null,
        indiamandals: null,
        indiabasins: null,
//indiastates: null,
//=====================================================================================================================================================================
//============================================================================NEWLY CREATED FOR SRSI, SWSI=============================================================
        indiaHDBasins: null,
        indiaHDReservoirs: null,
        //indiaSWSIBasinnames: null,
        indiaSWSISubbasinnames:null,
        indiaHDBasinsselected:"#",
        indiaHDReservoirsselected:"#",
        indiaSWSIBasinselected:"#",
        indiaSWSISubbasinselected:"#",
});
//==================================================================================COMMENT END FOR SRSI AND SWSI======================================================
//=======================================================================================================================================================================
};
setStats = (value) => {
let values;
if (value) {
values = value.map((result) => {
return [
parseInt(result.normal, 10),
parseInt(result.mild, 10),
parseInt(result.moderate, 10),
parseInt(result.severe, 10),
parseInt(result.extreme, 10),
];
});
}
//======================================================================================================================================================================
//================================================================================================FOR SRI===============================================================
//console.log(this.state.selectedMenu);
if (window.innerWidth > 1000) {
if (this.state.selectedMenu === 'Standardized Runoff Index-Annual Cumulative') {
this.setState({
        sri_stats: values[0],
        pie_categories: categories,
        visibleGraphPanel_pie: true,
});
}
//======================================================================================================================================================================
//=====================================================================FOR SGWI-TELANGANA===============================================================================
else if (this.state.selectedMenu === 'Standardized Groundwater Level Index-Telangana') {
this.setState({
        sri_stats: values[0],
        pie_categories: categories_sgwi,
        visibleGraphPanel_pie: true,
});
}
//======================================================================================================================================================================
//=======================================================================FOR SRSI=======================================================================================
//else if (this.state.selectedMenu === 'Standardized Reservoir Storage Index-reservoir')
else if (this.state.selectedMenu === 'Standardized Reservoir Storage Index')
{
this.setState({
        sri_stats: values[0],
        pie_categories: categories_srsi,
        visibleGraphPanel_pie: true,
});
}
//================================================================================FOR SWSI==============================================================================
else if (this.state.selectedMenu === 'Standardized Water Spread Index-Basin') {
this.setState({
        sri_stats: values[0],
        pie_categories: categories_swsi_basin,
        visibleGraphPanel_pie: true,
});
}
else if (this.state.selectedMenu === 'Standardized Water Spread Index-State') {
    this.setState({
        sri_stats: values[0],
        pie_categories: categories_swsi_state,
        visibleGraphPanel_pie: true,
    });
    }
else if (this.state.selectedMenu === 'Composite Hydrological Drought Index-chdi') {
this.setState({
        sri_stats: values[0],
        pie_categories: categories_chdi,
        visibleGraphPanel_pie: true,
});
}
}
else {
if (this.state.selectedMenu === 'Standardized Runoff Index-Annual Cumulative') {
this.setState({
        sri_stats: values[0],
        pie_categories: categories,
        visibleGraphPanel_pie: false,
});
}
else if (this.state.selectedMenu === 'Standardized Groundwater Level Index-Telangana') {
this.setState({
        sri_stats: values[0],
        pie_categories: categories_sgwi,
        visibleGraphPanel_pie: false,
});
}
//else if (this.state.selectedMenu === 'Standardized Reservoir Storage Index-reservoir')
else if (this.state.selectedMenu === 'Standardized Reservoir Storage Index')
{
this.setState({
        sri_stats: values[0],
        pie_categories: categories_sgwi,
        visibleGraphPanel_pie: false,
});
}
else if (this.state.selectedMenu === 'Standardized Water Spread Index-Basin') {
this.setState({
        sri_stats: values[0],
        pie_categories: categories_swsi_basin,
        visibleGraphPanel_pie: false,
});
}
else if (this.state.selectedMenu === 'Standardized Water Spread Index-State') {
    this.setState({
        sri_stats: values[0],
        pie_categories: categories_swsi_state,
        visibleGraphPanel_pie: false,
    });
    }
else if (this.state.selectedMenu === 'Composite Hydrological Drought Index-chdi') {
this.setState({
        sri_stats: values[0],
        pie_categories: categories_chdi,
        visibleGraphPanel_pie: false,
});
}}
//====================================================================================================================================================================
//======================================================================COMMENT END FOR SRSI AND SWSI=================================================================
};
setStates = (result) => {
//console.log(this.state.selectedLayer);
this.setState({
      indiastates: result,
      stateselected: "#",
      districtselected: "#",
      mandalselected: "#",
      indiabasins: result,
      basinselected:"#",
//====================================NEWLY CREATED FOR SRSI,SWSI AND CHDI=====================================
      indiaHDBasins: result,
      indiaHDReservoirs:result,
      indiaSWSIBasinnames:result,
      indiaSWSISubbasinnames:result,
      indiaHDBasinsselected:"#",
      indiaHDReservoirsselected:"#",
      indiaSWSIBasinselected:"#",
      indiaSWSISubbasinselected:"#",
//============================================================================COMMENT END FOR SRSI AND SWSI============================================================
});
};
setDistricts = (result) => {
this.setState({
indiadistricts: result,
districtselected: "#",
mandalselected: "#",
});
};
setMandals = (result) => {
this.setState({
indiamandals: result,
mandalselected: "#",
});
};
//======================================================================================================================================================================
//===========================================================NEWLY CREATED FOR SRSI-BASIN-RESERVOIR && SWSI BASIN-SUBBASIN =============================================
//SRSI(setHDBasins,setHDReservoirs,setSRSIBasinBoundary,setSRSIReservoirBoundary)
//SWSI(setSWSIBasin,setSWSISubbasin,setSWSIBasinBoundary,setSWSISubbasinBoundary)

setHDBasins = (result) => {this.setState({
indiaHDBasins: result,
indiaHDBasinsselected:"#",
});
};
setHDReservoirs= (result) => { this.setState({
indiaHDReservoirs: result,
indiaHDReservoirsselected:"#",
});//console.log("setHDReservoirs",this.state.indiaHDReservoirs)
};
setSWSIBasin = (result) => {this.setState({
indiaSWSIBasinnames: result,
indiaSWSIBasinselected:"#",
});
};
setSWSISubbasin= (result) => { this.setState({
indiaSWSISubbasinnames: result,
indiaSWSISubbasinselected:"#",
});
};
setSRSIBasinBoundary=(value)=>{
//console.log("srsi basin boun value ",value[0].basin_boundary)
this.setState({
srsibasinboundary:value[0].basin_boundary,
srsireservoirboundary:null,
})
}
setSRSIReservoirBoundary=(value)=>{
//console.log("srsi res boun value ",value[0].basin_boundary)
this.setState({
srsireservoirboundary:value[0].basin_boundary,
srsibasinboundary:null,
})
}
setSWSIBasinBoundary= (value)=>{
//console.log("swsi basin boun value ",value[0].basin_boundary)
this.setState({
swsibasinboundary:value[0].basin_boundary,
SRSIPoint:null,
swsisubbasinboundary:null,
})
}
setSWSISubbasinBoundary=(value)=>{
//console.log("swsi sub boun value ",value[0].basin_boundary)
this.setState({
swsisubbasinboundary:value[0].basin_boundary,
SRSIPoint:null,
swsibasinboundary:null,
})
}
//====================================================================================================================================================================
// get-srsi-point-2023, this api is using table india-res-pointdata in which res id, name, basin and geometry is present. 
//using this reservoir points are visible on map

setSRSIPoint = (menu) => {
    let selectedLayer = { ...this.state.selectedLayer };
    selectedLayer[menu] = "SRSI_2023_pointdata";
//console.log("iiiiiiiiii",this.state.date);
let date = new Date(moment(this.state.date, "DD-MM-YYYY"));
//console.log("ppp",date);

let day = new Date()
//console.log("qqq",day, this.state.selected_date);

let month = date.getMonth() + 1;
//console.log("uuu",month);
let year = date.getFullYear();
//console.log("fff",year);

   // axios.get(`${domain.DBServer}/get-SRSI-Point-2023`).then((result) => {
    axios.get(`${domain.DBServer}/get-srsi-reservoir-point-data`).then((result) => {
    //axios.get(`${domain.DBServer}/get-srsi-reservoir-point-data/:id/:year/:month/:day`).then((result) => {

        //axios.get(`${domain.DBServer}/get-srsi-reservoir-point-data/${e.target.feature.properties.name}/${e.target.feature.properties.year}/${e.target.feature.properties.month}/${e.target.feature.properties.Res_ID}`).then((result) => { 
        //${e.target.feature.properties.Res_ID}`
   // axios .get(`${domain.DBServer}/get-srsi-reservoir-point-data/${id}/${year}/${month}/${day}`).then((result) => {
      //if (result && result.data && result.data.length > 0 && result.data[0].boundary) {
        ////console.log("Combined GeoJSON data:", result.data[0].boundary);
        if (result){
        this.setState({
          selectedLayer: selectedLayer,
          SRSIPoint: result.data[0].boundary,
          visibleGraphPanel_pie: false,
          legendVisible: true,
          stateBoundary: null,
          visibleGraphPanel: false,
          visualGraphPanel_pid: false,
          sri_stats: null,
          chartData: null,
          latlng: null,
          stateselected: "#",
          districtselected: "#",
          mandalselected: "#",
          indiaHDBasinsselected: "#",
          indiaHDReservoirsselected: "#",
        }); // After setting SRSIPoint in the state
        //console.log("SRSIPoint:", this.state.SRSIPoint);
        
      }
    }).catch((error) => {
      console.error('Error fetching combined GeoJSON data:', error);
    });
  };
  
setStateBoundary = (value) => {this.setState({stateBoundary: value });
};
setDistrictValue = (value) => {
this.setState({
districtselected: value,
mandalselected: "#",
indiamandals: null,
});
};
setMandalValue = (value) => {this.setState({mandalselected: value});
};
setBasinValue = (value) => {this.setState({basinselected: value});
};
//=====================================================================================================================================================================
//==========================================================================NEWLY CREATED FOR SRSI AND SWSI============================================================
setHDBasinsValue = (value) => {
//console.log("setHDBasinsValue",value)
this.setState({indiaHDBasinsselected: value});
};
setHDReservoirsValue = (value) => {
//console.log("setHDreservoirValue",value)
this.setState({indiaHDReservoirsselected: value});
};
//setSWSIBasinValue = (value) => {
//this.setState({indiaSWSIBasinselected: value});
//};

setSWSIBasinValue = (value) => {
    this.setState
    ({indiaSWSIBasinselected: value,
  //indiaSWSISubbasinselected:"#",
    //indiaSWSIBasinnames: null,
    //indiaSWSISubbasinnames:null,
    //indiaSWSISubbasinselected:"#",
    
    });
    };

setSWSISubbasinValue = (value) => {
this.setState({indiaSWSISubbasinselected: value,
    //indiaSWSISubbasinnames:"#",
});
};
//======================================================================================================================================================================
//==========================================================================COMMENT END FOR SRSI AND SWSI===============================================================
toggleVisibleGraphPanel = () => {
if (this.state.chartData !== null || this.state.rchartData !== null) {
this.setState({
visibleGraphPanel: !this.state.visibleGraphPanel,
technicalnoteenable: false,
disclaimerenable: false,
popupMenuActive: false,
});
}
};

toggleVisibleGraphPanel_pie = () => {
if (this.state.sri_stats !== null || this.state.popup !== null) {
this.setState({visibleGraphPanel_pie: !this.state.visibleGraphPanel_pie});
}
};


setGradientContent = (p, name, availableDates, chartData,srsi_chart) => {
  //console.log("gradddd",moment(availableDates));
  this.setState({
    // position: p,
    visibleGraphPanel: true,
    //reservoirname:
     // "SRSI for " +
    //  name +
    //  " on " +
    //  moment(availableDates).format("DD MMM YYYY"),
      reservoirname:
      "Standardized Reservoir Storage Index - " +
      name.split(' ').map(w => w[0].toUpperCase() + w.substring(1).toLowerCase()).join(' '),
    reservoir_date: availableDates,
    rchartData: chartData,
    popupMenuActive: false,
    srsi_chart:srsi_chart,
  });
};

handleVisibleGraphPanelOnMapClick = () => {
this.setState({visibleGraphPanel: true});
};
toggleSelectedNodeStatus = (menu) => {
//console.log(this.state.selectedNodeStaus);
let selectedNodeStaus = { ...this.state.selectedNodeStatus };
//console.log(menu);
//console.log(this.state.selectedNodeStaus);
selectedNodeStaus[menu] = !selectedNodeStaus[menu];
this.setState({selectedNodeStaus: selectedNodeStaus});
};
handleAnimationChange = () => {
this.setState({ visible: !this.state.visible});
};
setSelectedMenu = (menu) => {this.setState({
selectedMenu: menu,
visibleGraphPanel_pie: false,
showInfo: false,
});
};
setDateControls = (dateControls) => {

  console.log("dateControls",dateControls,this.state.selected)
let selected_date = moment.isMoment(this.state.date)
? this.state.date.format(this.state.dateFormat).toLowerCase()
: moment(this.state.date, this.state.dateDisplayFormat)
.format(this.state.dateFormat)
.toLowerCase();
let availableDates = [...dateControls.availableDates];
let availableDatesStr = availableDates.map((date) => {
return moment(date, this.state.dateDisplayFormat)
.format(this.state.dateFormat)
.toLowerCase();
});
this.setState({
date: dateControls.date,
availableDates: dateControls.availableDates,
slideTracker: availableDatesStr.indexOf(selected_date),
dateFormat: dateControls.dateFormat,
dateDisplayFormat: dateControls.dateDisplayFormat,
sliderDateFormat: dateControls.sliderDateFormat,
regex: dateControls.regex,
popup: null,
visibleGraphPanel: false,
latlng: false,
showInfo: false,
});
};
setSelectedLayer = (main) => {
//console.log(main);
console.log("chdimain",main)

let selectedLayer = { ...this.state.selectedLayer };
if (main !== "Standardized Groundwater Level Index-Telangana" && main!="Composite Hydrological Drought Index-chdi")
this.getIndiaBoundary();
// if (main !== "Composite Hydrological Drought Index-Telangana")
// this.getIndiaBoundary();
if (new URLSearchParams(this.props.location.search).get("date") &&
selectedLayer[main] === undefined)
{ selectedLayer[main] =
moment(
new URLSearchParams(this.props.location.search).get("date"),
this.state.dateDisplayFormat
)
.format(this.state.dateFormat)
.toLowerCase() + file_ext[main];
} else { selectedLayer[main] = moment.isMoment(this.state.date)
? this.state.date.format(this.state.dateFormat).toLowerCase() +
file_ext[main]
: moment(this.state.date, this.state.dateDisplayFormat)
.format(this.state.dateFormat)
.toLowerCase() + file_ext[main];
}
if (main === "Standardized Groundwater Level Index-Telangana") {
this.setState({
              selectedLayer: selectedLayer,
              legendVisible: true,
              visibleGraphPanel: false,
              visibleGraphPanel_pie: false,
              stateselected: "TELANGANA",
              districtselected: "#",
              mandalselected: "#",
              stateBoundary: null,
              latlng: null,
              chartData: null,
              SRSIPoint: null,
              popup: null,
});
} else if (main === "Standardized Runoff Index-Annual Cumulative") {
this.setState({
              selectedLayer: selectedLayer,
              legendVisible: true,
              visibleGraphPanel: false,
              visibleGraphPanel_pie: true,
              stateselected: "#",
              districtselected: "#",
              mandalselected: "#",
              stateBoundary: null,
              latlng: null,
              chartData: null,
              SRSIPoint: null,
              popup: null,
});
} else if (main === "Standardized Reservoir Storage Index-reservoir") {
    this.setState({
              selectedLayer: selectedLayer,
              legendVisible: true,
              visibleGraphPanel: false,
              visibleGraphPanel_pie: window.innerWidth > 1000 ? true : false,
              sri_stats: null,
              indiaHDBasinsselected:"#",
              indiaHDReservoirsselected:"#",
              stateBoundary: null,
              latlng: null,
              chartData: null,
              //SRSIPoint: null,
              //popup: null,
    });
} else if (main === "Standardized Water Spread Index-Basin") {
this.setState({
              selectedLayer: selectedLayer,
              legendVisible: true,
              visibleGraphPanel: false,
              visibleGraphPanel_pie: window.innerWidth > 1000 ? true : false,
              stateselected: "#",
              districtselected: "#",
              indiaSWSIBasinselected:"#",
              indiaSWSISubbasinselected:"#",
              stateBoundary: null,
              latlng: null,
              chartData: null,
              SRSIPoint: null,
              popup: null,
});


} else if (main === "Standardized Water Spread Index-State") {
  this.setState({
              selectedLayer: selectedLayer,
              legendVisible: true,
              visibleGraphPanel: false,
              visibleGraphPanel_pie: window.innerWidth > 1000 ? true : false,
              stateselected: "#",
              districtselected: "#",
              indiaSWSIBasinselected:"#",
              indiaSWSISubbasinselected:"#",
              stateBoundary: null,
              latlng: null,
              chartData: null,
              SRSIPoint: null,
              popup: null,
  });

} else if (main === "Composite Hydrological Drought Index-chdi") {
this.setState({
              selectedLayer: selectedLayer,
              legendVisible: true,
              visibleGraphPanel: false,
              visibleGraphPanel_pie: false,
              stateselected: "TELANGANA",
              districtselected: "#",
              mandalselected: "#",
              stateBoundary: null,
              latlng: null,
              chartData: null,
              SRSIPoint: null,
                  popup: null,
});
} else {
    this.setState({
              selectedLayer: selectedLayer,
              legendVisible: true,
              visibleGraphPanel: false,
              visibleGraphPanel_pie: false,
              sri_stats: null,
              stateselected: "#",
              districtselected: "#",
              mandalselected: "#",
              stateBoundary: null,
              latlng: null,
              chartData: null,
              SRSIPoint: null,
              popup: null
      // selectedMaps:selectedMaps
    });
  }
};

setStateInfo = (info) => { this.setState({stateInfo: info})};
setLegend = (src) => { this.setState({legend: src})};
setLatLng = (latlng) => {
this.setState({latlng: latlng});
};
setOnClickDetails = (data) => {
this.setState({onClickDetails: data});
};

emptyChartData = () => {
  this.setState({
    reservoirname: null,
    rchartData: null,
    visibleGraphPanel: false
  })
}

// chart functions fpr all modules-sri,srsi,swsi,sgwi and chdi=======================
async makeChartDataAvailableDays(
) {
    this.setState({ chartloading: true,chartData: null, rchartData: null});
    let chartData = [],
    funs=this.state.selectedMenu,
    funName=funs.split(" ").join("-").toLowerCase(),
    chartDates = [];
    //console.log(funs,funName,"qqqqqqqqqqfuname")

//=====================result1----SWSI-BASIN PART=======================================
if (funName === "standardized-water-spread-index-basin") {

    let result1 = await axios({
        method: "post",
        url: `${domain.DBServer}/get-pixel-value-standardized-water-spread-index-basin`,
        data: { lat: this.state.latlng ? this.state.latlng.lat : 0, // Use default value (0) if latlng is not defined
        lon: this.state.latlng ? this.state.latlng.lng : 0,
        },
        });
        
        let activeDate = moment.isMoment(this.state.date)
        ? this.state.date.format(this.state.dateFormat).toLowerCase()
        : moment(this.state.date, this.state.dateDisplayFormat)
        .format(this.state.dateFormat)
        .toLowerCase();
      
        
        if (result1) {
        if (result1.data) {
        result1.data.map((item) => {
            //let date = item.filename.match(/[a-zA-Z]{3}\d{4}/);
           // let date = item.filename.match(this.state.regex)[0];
          // let date = (filename) => (match => match ? `${match[1]}${{Jan:'01',Feb:'02',Mar:'03',Apr:'04',May:'05',Jun:'06',Jul:'07',Aug:'08',Sep:'09',Oct:'10',Nov:'11',Dec:'12'}[match[2]]}${match[3]}` : null)(filename.match(/[a-zA-Z]{3}(\d{4})/));
          let date = item.filename.match(/[a-zA-Z]+_([a-zA-Z]{3}\d{4})_[a-zA-Z]+/)?.[1] ? moment(item.filename.match(/[a-zA-Z]+_([a-zA-Z]{3}\d{4})_[a-zA-Z]+/)[1], "MMMYYYY").format("YYYYMMDD") : null;

        let chartDate = moment(date);
        if (activeDate === date) {
        this.setState({
        pointInfo:
        item.pixel_val !== null ? item.pixel_val.toFixed(3) : null
        });
        }
        if (item.pixel_val !== null) {
        chartData.push([
        moment(chartDate, "DD-MM-YYYY").format(),
        Number(item.pixel_val).toFixed(2)
        ]);
        } else {
        return [
        Date.UTC(
        parseInt(chartDate.format("YYYY"), 10),
        parseInt(chartDate.format("MM"), 10) - 1,
        parseInt(chartDate.format("DD"), 10)
        ),
        null
        ];
        }
        
        });
        
        result1.data.map(item => {
            let date = item.filename.match(/\d+/g);
            //console.log(date,"eeeeeeeee")
            let chartDate = moment(date);
            //console.log(chartDate,"XXXXXXXX")
            chartDates.push(
            moment(chartDate, "MM-YYYY").format("MMM YYYY")
        );
        });
      
        removeDuplicates(chartData);
        chartData.sort();
        //console.log(chartData);
        //console.log(chartDates,"swsichartDatessssssssssssssssssssssssssssssssssssssss");
        var dates = chartData.map(function (x) {
        return new Date(x[0]);
        });
        //console.log("water datesssssssssssssss",chartDates,chartData);
            if ( this.state.selectedMenu.split(" ").join("-").toLowerCase() ===
            "standardized-water-spread-index-basin")
            {
            this.setState({
            chartData: {
            seriesData: chartData,
            categories: chartDates,
            title: `Standardized Water Spread Index`,
            yAxisTitle: `Z-Score`,
            xAxisTitle: "Year",
            maximumDate: new Date(Math.max.apply(null, dates)),
            minimumDate: new Date(Math.min.apply(null, dates)),
            name: this.state.selectedMenu,
            type: "bar",
            },
            chartloading: false,
            technicalnoteenable: false,
            disclaimerenable: false,
            });
            }
        }
        }
        }
//===========================result3----SWSI-STATE PART===================

else if (funName === "standardized-water-spread-index-state") {

    let result3 = await axios({
        method: "post",
        url: `${domain.DBServer}/get-pixel-value-standardized-water-spread-index-state`,
        data: { lat: this.state.latlng ? this.state.latlng.lat : 0, // Use default value (0) if latlng is not defined
        lon: this.state.latlng ? this.state.latlng.lng : 0,
        },
        });
        
        let activeDate = moment.isMoment(this.state.date)
        ? this.state.date.format(this.state.dateFormat).toLowerCase()
        : moment(this.state.date, this.state.dateDisplayFormat)
        .format(this.state.dateFormat)
        .toLowerCase();
        //console.log("accccccdate",activeDate);
        //console.log("r1111111",result3);
        
        if (result3) {
        if (result3.data) {
            //console.log("swsiqqqqqqqqqq",result3.data)
        result3.data.map((item) => {
          // let date = (filename) => (match => match ? `${match[1]}${{Jan:'01',Feb:'02',Mar:'03',Apr:'04',May:'05',Jun:'06',Jul:'07',Aug:'08',Sep:'09',Oct:'10',Nov:'11',Dec:'12'}[match[2]]}${match[3]}` : null)(filename.match(/[a-zA-Z]{3}(\d{4})/));
          let date = item.filename.match(/[a-zA-Z]+_([a-zA-Z]{3}\d{4})_[a-zA-Z]+/)?.[1] ? moment(item.filename.match(/[a-zA-Z]+_([a-zA-Z]{3}\d{4})_[a-zA-Z]+/)[1], "MMMYYYY").format("YYYYMMDD") : null;

        //console.log('testdate swsi index date',date)
        let chartDate = moment(date);
        //console.log("cvvvvvvvvchartvvvvvvvvv",result3.data,chartDate);
        if (activeDate === date) {
        this.setState({
        pointInfo:
        item.pixel_val !== null ? item.pixel_val.toFixed(3) : null
        });
        }
        if (item.pixel_val !== null) {
        chartData.push([
        moment(chartDate, "DD-MM-YYYY").format(),
        Number(item.pixel_val).toFixed(2)
        ]);
        } else {
        return [
        Date.UTC(
        parseInt(chartDate.format("YYYY"), 10),
        parseInt(chartDate.format("MM"), 10) - 1,
        parseInt(chartDate.format("DD"), 10)
        ),
        null
        ];
        }
        
        });
        
        result3.data.map(item => {
            let date = item.filename.match(/\d+/g);
            //console.log(date,"eeeeeeeee")
            let chartDate = moment(date);
            //console.log(chartDate,"XXXXXXXX")
            chartDates.push(
            moment(chartDate, "MM-YYYY").format("MMM YYYY")
        );
        });
        removeDuplicates(chartData);
        chartData.sort();
        //console.log(chartData);
        //console.log(chartDates,"swsichartDatessssssssssssssssssssssssssssssssssssssss");
        var dates = chartData.map(function (x) {
        return new Date(x[0]);
        });
        //console.log("water datesssssssssssssss",chartDates,chartData);
            if ( this.state.selectedMenu.split(" ").join("-").toLowerCase() ===
            "standardized-water-spread-index-state")
            {
            this.setState({
            chartData: {
            seriesData: chartData,
            categories: chartDates,
            title: `Standardized Water Spread Index`,
            yAxisTitle: `Z-Score`,
            xAxisTitle: "Year",
            maximumDate: new Date(Math.max.apply(null, dates)),
            minimumDate: new Date(Math.min.apply(null, dates)),
            name: this.state.selectedMenu,
            type: "bar",
            },
            chartloading: false,
            technicalnoteenable: false,
            disclaimerenable: false,
            });
            }
        }
        }
        }

//========= chdi new==============

else if (funName === "composite-hydrological-drought-index-chdi")
 {  
    let result4 = await axios({
    method: "post",  
    url: `${domain.DBServer}/get-pixel-value-composite-hydrological-drought-index-chdi`,
    data: { lat: this.state.latlng ? this.state.latlng.lat : 0,
    lon: this.state.latlng ? this.state.latlng.lng : 0,
    },
    });
    let activeDate = moment.isMoment(this.state.date)
    ? this.state.date.format(this.state.dateFormat).toLowerCase()
    : moment(this.state.date, this.state.dateDisplayFormat)
    .format(this.state.dateFormat)
    .toLowerCase();
    //console.log("noxx",activeDate);
    //console.log("lummm",result4);
    //console.log("siteee",result4);

    if (result4) {
    if (result4.data) {
        //console.log("compoqqqqqqqqqq",result4.data)
    result4.data.map((item) => {
    //let date = item.filename.match(this.state.regex)[0];
    let date = item.filename.match(/\d{6}/)
    ? moment(item.filename.match(/\d{6}/)[0], "YYYYMM").format("YYYYMMDD")
    : null;
  
    //console.log('testdate compo index date',date)
    let chartDate = moment(date);
    //console.log("chartcompooo",result4.data,chartDate);
    if (activeDate === date) {
    this.setState({
    pointInfo:
    item.pixel_val !== null ? item.pixel_val.toFixed(3) : null
    });
    }
    if (item.pixel_val !== null) {
    chartData.push([
    moment(chartDate, "DD-MM-YYYY").format(),
    Number(item.pixel_val).toFixed(2)
    ]);
    } else {
    return [
    Date.UTC(
    parseInt(chartDate.format("YYYY"), 10),
    parseInt(chartDate.format("MM"), 10) - 1,
    parseInt(chartDate.format("DD"), 10)
    ),
    null
    ];
    }

    });

result4.data.map(item => {
    let date = (item.filename.match(/\d{4}/) || [null])[0];
//console.log(date, "popppp");
//let date = item.filename.match(/\d+/g);
////console.log(date,"popppp")
let chartDate = moment(date);
//console.log(chartDate,"chchchch")
chartDates.push(
moment(chartDate, "MM-YYYY").format("MMM YYYY")
);
});
    removeDuplicates(chartData);
    chartData.sort();
    //console.log(chartData);
    //console.log(chartDates,"chdichartDatessssssssssssssssssssssssssssssssssssssss");
    var dates = chartData.map(function (x) {
    return new Date(x[0]);
    });
//console.log("compo datesssssssssssssss",chartDates,chartData);
if ( this.state.selectedMenu.split(" ").join("-").toLowerCase() ===
"composite-hydrological-drought-index-chdi")
    {
    this.setState({
    chartData: {
    seriesData: chartData,
    categories: chartDates,
    title: `Composite Hydrological Drought Index Telangana`,
    yAxisTitle: `Z-Score`,
    xAxisTitle: "Date",
    maximumDate: new Date(Math.max.apply(null, dates)),
    minimumDate: new Date(Math.min.apply(null, dates)),
    name: this.state.selectedMenu,
    type: "bar",
    },
    chartloading: false,
    technicalnoteenable: false,
    disclaimerenable: false,
    });
    }}}
    } 
//==============================result----SRI-SGWI- these are existing modules==================================
        else  {
            ////console.log("this.state.se",this.state.selectedMenu)
let result = await axios({
    method: "post",
    url: `${domain.DBServer}/get-pixel-value-${this.state.selectedMenu
    .split(" ")
    .join("-")
    .toLowerCase()}`,
    data: {
    lat: this.state.latlng ? this.state.latlng.lat : 0, // Use default value (0) if latlng is not defined
    lon: this.state.latlng ? this.state.latlng.lng : 0, // Use default value (0) if latlng is not defined
    },
    });

let activeDate = moment.isMoment(this.state.date)
    ? this.state.date.format(this.state.dateFormat).toLowerCase()
    : moment(this.state.date, this.state.dateDisplayFormat)
    .format(this.state.dateFormat)
    .toLowerCase();
    //console.log("lumos",activeDate);
    //console.log("lummm",result);
    if (result) {
        if (result.data) {
          result.data.map((item) => {
            let date = item.filename.match(this.state.regex)[0];
            let chartDate = moment(date,this.state.selectedMenu.split(" ").join("-").toLowerCase() ==="standardized-groundwater-level-index-telangana"?"MMMYYYY":"YYYYMMDD");
            //console.log(chartDate);
            if (activeDate === date) {
              this.setState({
                showInfo: true,
                pointInfo:
                  item.pixel_val !== null ? item.pixel_val.toFixed(3) : null,
              });
            }
            if (item.pixel_val !== null) {
              chartData.push([
                Date.UTC(
                  parseInt(chartDate.format("YYYY"), 10),
                  parseInt(chartDate.format("MM"), 10) - 1,
                  parseInt(chartDate.format("DD"), 10)
                ),
                Number(item.pixel_val).toFixed(2),
              ]);
            } else {
              return [
                Date.UTC(
                  parseInt(chartDate.format("YYYY"), 10),
                  parseInt(chartDate.format("MM"), 10) - 1,
                  parseInt(chartDate.format("DD"), 10)
                ),
                null,
              ];
            }
            return true;
          });
          result.data.map((item) => {
            let date = item.filename.match(this.state.regex)[0];
            let chartDate = moment(this.state.date,this.state.selectedMenu.split(" ").join("-").toLowerCase() ==="standardized-groundwater-level-index-telangana"?"MMMYYYY":"YYYYMMDD").format("DD MMM YYYY")
            chartDates.push(chartDate);
            return true;
          });
removeDuplicates(chartData);
chartData.sort();
//console.log(chartDates,"chartDatessssssssssssssssssssssssssssssssssssssss");
var dates = chartData.map(function (x) {
return new Date(x[0]);
});
//console.log("chart datesssssssssssssss",chartDates,chartData);
    if ( this.state.selectedMenu.split(" ").join("-").toLowerCase() ===
    "standardized-groundwater-level-index-telangana")
    {
    this.setState({
    chartData: {
    seriesData: chartData,
    categories: chartDates,
    title: `Standardized Groundwater Level Index Telangana`,
    yAxisTitle: `Z-Score`,
    xAxisTitle: "Year",
    maximumDate: new Date(Math.max.apply(null, dates)),
    minimumDate: new Date(Math.min.apply(null, dates)),
    name: this.state.selectedMenu,
    type: "bar",
    },
    chartloading: false,
    technicalnoteenable: false,
    disclaimerenable: false,
    });

} else {
this.setState({
chartData: {
seriesData: chartData,
title: ` ${this.state.selectedMenu}`,
yAxisTitle: `Z- Score`,
xAxisTitle:'Year',
maximumDate: new Date(Math.max.apply(null, dates)),
minimumDate: new Date(Math.min.apply(null, dates)),
name: this.state.selectedMenu,
type: "area",
},
chartloading: false,
technicalnoteenable: false,
disclaimerenable: false,
});
}
}
}
}
}

common_func = (value) => {
let mod = moment(value, "YYYYMMDD");
let date = new Date(mod);
//console.log(date);
let day = date.getDate();
let mm = date.getMonth() + 1;
let year = date.getFullYear();
//console.log(day, mm, year);
if (
this.state.stateselected !== "#" &&
this.state.districtselected !== "#" &&
this.state.basinselected !== "#" &&
this.state.reservoirselected !== "#"
) {
axios.get(`${domain.DBServer}/get-sri-state-stats/${this.state.stateselected}/${this.state.districtselected}/${year}/${mm}/${day}` )
.then((result) => {
if (result) {
this.setStats(result.data);
}
});
} else if (
this.state.stateselected !== "#" && this.state.districtselected === "#"
) {
axios.get( `${domain.DBServer}/get-sri-state-stats/${this.state.stateselected}/${year}/${mm}/${day}`)
.then((result) => {
if (result) {this.setStats(result.data)}
});
} else if (this.state.stateselected === "#" && this.state.districtselected === "#"
) {
axios.get(`${domain.DBServer}/get-sri-state-stats/${year}/${mm}/${day}`)
.then((result) => {
if (result) {this.setStats(result.data)}
});
}
};
common_func_T = (value) => {
console.log("functionnnnnnnnnnnnn",this.state.selectedMenu,value);
let mod = moment(value, "MMMYYYY");
let date = new Date(mod);
//console.log(date);
let day = date.getDate();
let mm = date.getMonth() + 1;
let year = date.getFullYear();


if (this.state.selectedMenu ==="Coomposite Hydrological Drought Index-chdi"){
  if (
    this.state.stateselected !== "#" &&
    this.state.districtselected !== "#" &&
    this.state.mandalselected !== "#"
    ) {
    axios.get(`${domain.DBServer}/get-chdi-state-stats-T/${this.state.stateselected}/${this.state.districtselected}/${this.state.mandalselected}/${year}/${mm}/${day}`)
    .then((result) => {
    if (result) {this.setStats(result.data)}
    });
    } else if (
    this.state.stateselected !== "#" &&
    this.state.districtselected !== "#" &&
    this.state.mandalselected === "#"
    ) {
    axios.get( `${domain.DBServer}/get-chdi-state-stats-T/${this.state.stateselected}/${this.state.districtselected}/${year}/${mm}/${day}`)
    .then((result) => {
    if (result) {this.setStats(result.data)}
    });
    } else if (
    this.state.stateselected !== "#" &&
    this.state.districtselected === "#"
    ) {
    axios.get(`${domain.DBServer}/get-chdi-state-stats-T/${this.state.stateselected}/${year}/${mm}/${day}`)
    .then((result) => {
    if (result) {this.setStats(result.data)}
    });
    }

}
else{
  //console.log(day, mm, year);
if (
  this.state.stateselected !== "#" &&
  this.state.districtselected !== "#" &&
  this.state.mandalselected !== "#"
  ) {
  axios.get(`${domain.DBServer}/get-sri-state-stats-T/${this.state.stateselected}/${this.state.districtselected}/${this.state.mandalselected}/${year}/${mm}/${day}`)
  .then((result) => {
  if (result) {this.setStats(result.data)}
  });
  } else if (
  this.state.stateselected !== "#" &&
  this.state.districtselected !== "#" &&
  this.state.mandalselected === "#"
  ) {
  axios.get( `${domain.DBServer}/get-sri-state-stats-T/${this.state.stateselected}/${this.state.districtselected}/${year}/${mm}/${day}`)
  .then((result) => {
  if (result) {this.setStats(result.data)}
  });
  } else if (
  this.state.stateselected !== "#" &&
  this.state.districtselected === "#"
  ) {
  axios.get(`${domain.DBServer}/get-sri-state-stats-T/${this.state.stateselected}/${year}/${mm}/${day}`)
  .then((result) => {
  if (result) {this.setStats(result.data)}
  });
  }
}

};
monthChange = (value) => {
//console.log(value);
this.common_func_T(value);
};
onSlide = (event) => {
event.preventDefault();
let value = parseInt(event.target.value, 10);
//console.log(value);
let selected_date = this.state.availableDates[value]
.format(this.state.dateFormat)
.toLowerCase();
if (this.state.selectedMenu === "Standardized Runoff Index-Annual Cumulative")
{this.common_func(selected_date)}
else if (this.state.selectedMenu ==="Standardized Groundwater Level Index-Telangana")
{this.common_func_T(this.state.availableDates[value])}
else if ( this.state.selectedMenu ==="Standardized Reservoir Storage Index-reservoir")
{this.common_func(this.state.availableDates[value])}
else if (this.state.selectedMenu ==="Standardized Water Spread Index")
{this.common_func(this.state.availableDates[value])}
else if (this.state.selectedMenu ==="Composite Hydrological Drought Index-chdi")
// else if (this.state.selectedMenu ==="Composite Hydrological Drought Index-chdi")
{this.common_func_T(this.state.availableDates[value])}
let selectedLayer = { ...this.state.selectedLayer };
let menu = this.state.selectedMenu;
selectedLayer[menu] = selected_date + file_ext[menu];
this.setState({
slideTracker: value,
date: this.state.availableDates[value],
selectedLayer: selectedLayer,
popup: null,
visibleGraphPanel: false,
showInfo: false,
latlng: null
});
};
onClickSlideLeft = () => {
let slideTracker = this.state.slideTracker;
console.log("this.state.dateformat",this.state.dateFormat,this.state.availableDates[slideTracker],this.state.availableDates,slideTracker)
if (slideTracker > 0) {
slideTracker = slideTracker - 1}
let selected_date = this.state.availableDates[slideTracker]
.format(this.state.dateFormat)
.toLowerCase();
if (this.state.selectedMenu === "Standardized Runoff Index-Annual Cumulative")
{this.common_func(selected_date)}
else if (this.state.selectedMenu ==="Standardized Groundwater Level Index-Telangana")
{this.common_func_T(this.state.availableDates[slideTracker])}
else if (this.state.selectedMenu === "Standardized Reservoir Storage Index-reservoir")
{this.common_func(selected_date)}
else if ( this.state.selectedMenu ==="Standardized Water Spread Index")
{this.common_func(selected_date)}
else if (this.state.selectedMenu ==="Composite Hydrological Drought Index-chdi")
//else if (this.state.selectedMenu ==="Composite Hydrological Drought Index-chdi")
{this.common_func_T(this.state.availableDates[slideTracker])}
let selectedLayer = { ...this.state.selectedLayer };
let menu = this.state.selectedMenu;
selectedLayer[menu] = selected_date + file_ext[menu];
this.setState({
slideTracker: slideTracker,
date: this.state.availableDates[slideTracker],
selectedLayer: selectedLayer,
popup: null,
visibleGraphPanel: false,
showInfo: false,
latlng: null
});
};
onClickSlideRight = () => {
let slideTracker = this.state.slideTracker;
if (slideTracker < this.state.availableDates.length - 1) {
slideTracker = slideTracker + 1}
let selected_date = this.state.availableDates[slideTracker]
.format(this.state.dateFormat)
.toLowerCase();
//console.log(selected_date);
if (this.state.selectedMenu === "Standardized Runoff Index-Annual Cumulative")
{this.common_func(selected_date)}
else if (this.state.selectedMenu ==="Standardized Groundwater Level Index-Telangana")
{this.common_func_T(this.state.availableDates[slideTracker])}
else if (this.state.selectedMenu ==="Standardized Reservoir Storage Index-reservoir")
{this.common_func(selected_date)}
else if (this.state.selectedMenu ==="Standardized Water Spread Index")
{this.common_func(selected_date)}
else if (this.state.selectedMenu ==="Composite Hydrological Drought Index-chdi")
//else if (this.state.selectedMenu ==="Composite Hydrological Drought Index-chdi")
{this.common_func_T(this.state.availableDates[slideTracker])}
let selectedLayer = { ...this.state.selectedLayer };
let menu = this.state.selectedMenu;
selectedLayer[menu] = selected_date + file_ext[menu];
this.setState({
slideTracker: slideTracker,
date: this.state.availableDates[slideTracker],
selectedLayer: selectedLayer,
popup: null,
visibleGraphPanel: false,
showInfo: false,
latlng: null
});
};
getIndiaBoundary = () => {
axios.post(`${domain.DBServer}/get-india-boundary`).then((result) => {
if (result) { this.setState({stateBoundary: result.data[0].boundary})}
});
};
componentDidMount() {
this.getIndiaStatesBoundary();
if (window.innerWidth < 1025) {
this.setState({
visible: false,
legendVisible: false,
visibleGraphPanel_pie: false,
x: 0,
y: 0,
width: 300,
height: 300,
})
}}
getIndiaStatesBoundary = () => {
axios.post(`${domain.DBServer}/get-india-states-boundary`).then((result) => {
if (result) {
this.setState({india_states_boundary: result.data[0].india_boundary});
}
});
};
componentDidUpdate(prevProps, prevState) {
      if (this.state.date !== prevState.date) {
      let selected_date = moment.isMoment(this.state.date)
      ? this.state.date.format(this.state.dateFormat).toLowerCase()
      : moment(this.state.date, this.state.dateDisplayFormat)
      .format(this.state.dateFormat)
      .toLowerCase();
      let selectedLayer = { ...this.state.selectedLayer };
      selectedLayer[this.state.selectedMenu] =
      selected_date + file_ext[this.state.selectedMenu];
      let availableDates = [...this.state.availableDates];
      let availableDatesStr = availableDates.map((date) => {
      return moment(date, this.state.dateDisplayFormat)
      .format(this.state.dateFormat)
      .toLowerCase();
      });

this.setState({
selectedLayer: selectedLayer,
slideTracker: availableDatesStr.indexOf(selected_date),
});

}
}
datesetting = () => {
this.setState({datesloading: this.props.datesloading});
};
updateTabs = (id) => {
//console.log(id);
let tabs = this.state.tabs;
let newtabs = tabs.map((tab, index) => {
if (tab.id === id) {
if (tab.active === true) {
tab.active = false }
else {tab.active = true;
}
} else { tab.active = false;
}
return tab;
});
//console.log(newtabs);
return newtabs;
};
incrementCounter = () => {this.setState({clickcount: this.state.clickcount + 1})};

handleTabClick = (id) => {this.setState({tabs: this.updateTabs(id) }) };
handleDialogClose = () => { this.setState({ technicalnoteenable: false }) };
handleDialogDClose = () => {this.setState({disclaimerenable: false}); };
handleTechnicalNote = () => {
this.setState({
technicalnoteenable: true,
disclaimerenable: false,
visibleGraphPanel: false,
visible: window.innerWidth > 1000 ? true : false,
});
};
handleDisclaimer = () => {
this.setState({
technicalnoteenable: false,
disclaimerenable: true,
visible: window.innerWidth > 1000 ? true : false,
});
};
toggle = () => {
this.setState({modal: !this.state.modal });
};
render() {
console.log("chdiselectedmenu",this.state.selectedMenu);
//console.log("indiaSWSIBasinnamesindiaSWSIBasinnames",this.state.indiaSWSIBasinnames)
let selectedRegion =
this.state.stateselected !== "#" &&
this.state.districtselected !== "#" &&
this.state.mandalselected !== "#"
? this.state.mandalselected
: this.state.stateselected !== "#" &&
this.state.districtselected !== "#"
? this.state.districtselected
: this.state.stateselected !== "#"
? this.state.stateselected
: "India";
let params = new URLSearchParams(this.props.location.search);
//console.log(params.get("selected"));
let menuList = this.state.tabs.map((child) => {
return (
<div
style={{
padding: "1px",
borderRadius: "4px",
margin: "4px",
backgroundColor: colors.final_side_sub,
}}
key={child.id}
>
<TreeNode
          getIndiaBoundary={this.getIndiaBoundary}
          clickcount={this.state.clickcount}
          incrementCounter={this.incrementCounter}
          monthChange={this.monthChange}
          data={child}
          id={child.id}
          active={child.active}
          handleTabClick={this.handleTabClick}
          margin={0}
          date={this.state.date}
          setDateControls={this.setDateControls}
          slideTracker={this.state.slideTracker}
          datesloading={this.datesetting}
          color={colors["sidebar-main-menu"]}
          selectedLayerLink={params.get("selected")}
          toggleSelectedNodeStatus={this.toggleSelectedNodeStatus}
//========================================================================================================================================
//=============================================NEWLY CREATED FOR SRSI and SWSI IP============================================================
          setHDBasins={this.setHDBasins}
          setHDReservoirs={this.setHDReservoirs}
          setHDBasinsValue={this.setHDBasinsValue}
          setHDReservoirsValue={this.setHDReservoirsValue}
          setSRSIBasinBoundary={this.setSRSIBasinBoundary}
          setSRSIReservoirBoundary={this.setSRSIReservoirBoundary}

          setSWSIBasin={this.setSWSIBasin}
          setSWSISubbasin={this.setSWSISubbasin}
          setSWSIBasinValue={this.setSWSIBasinValue}
          setSWSISubbasinValue={this.setSWSISubbasinValue}
          setSWSIBasinBoundary={this.setSWSIBasinBoundary}
          setSWSISubbasinBoundary={this.setSWSISubbasinBoundary}

          indiaHDBasins={this.state.indiaHDBasins}
          indiaHDReservoirs={this.state.indiaHDReservoirs}
          indiaHDBasinsselected={this.state.indiaHDBasinsselected}
          indiaHDReservoirsselected={this.state.indiaHDReservoirsselected}
          indiaSWSIBasinnames={this.state.indiaSWSIBasinnames}
          indiaSWSISubbasinnames={this.state.indiaSWSISubbasinnames}
          indiaSWSIBasinselected={this.state.indiaSWSIBasinselected}
          indiaSWSISubbasinselected={this.state.indiaSWSISubbasinselected}
          //=================================================================END OF COMMENT===================================================================
          //======================================================================================================================================================
          setStates={this.setStates}
          setStateValue={this.setStateValue}
          setStateBoundary={this.setStateBoundary}
          indiastates={this.state.indiastates}
          stateselected={this.state.stateselected}
          setDistricts={this.setDistricts}
          setDistrictValue={this.setDistrictValue}
          indiadistricts={this.state.indiadistricts}
          districtselected={this.state.districtselected}
          setMandals={this.setMandals}
          setMandalValue={this.setMandalValue}
          indiamandals={this.state.indiamandals}
          mandalselected={this.state.mandalselected}
          srsibasinboundary={this.state.srsibasinboundary}
          srsireservoirboundary={this.state.srsireservoirboundary}
          swsibasinboundary={this.state.swsibasinboundary}
          swsisubbasinboundary={this.state.swsisubbasinboundary}
          setStats={this.setStats}
          setSelectedLayer={this.setSelectedLayer}
          setSelectedMenu={this.setSelectedMenu}
          selectedNodeStaus={this.state.selectedNodeStaus}
          selectedMenu={this.state.selectedMenu}
          //created 12 oct fr srsi point data
          setSRSIPoint={this.setSRSIPoint}
          setSRSIPointByState={this.setSRSIPointByState}
/>
</div>
);
});
return (
<div
style={{ backgroundColor: "#ffffff", height: "100%" }}
ref={(ref) => {this._menuBlock = ref }}
>
<AboutModal
modal={this.props.hdmodal}
toggle={this.props.toggle}
title={pagecontent.title}
bodycontent={pagecontent.bodycontent}
link={pagecontent.link}
/>
<Sidebar.Pushable
as={Segment}
style={{
marginTop: "0px",
backgroundColor: colors.background,
border: "0px",
}}
>
<Sidebar
as={Menu}
animation="slide out"
direction="left"
icon="labeled"
inverted
vertical
visible={this.state.visible}
style={{
backgroundColor: colors.sidebarBackground,
textAlign: "right",
width: "260px",
padding: "0px",
border: "0px",
}}
>
{this.state.layerExist === true ? (
<div></div>
) : (
<div style={{ padding: "10px", textAlign: "left" }}>
<Message warning><Message.Header>Data does not exist </Message.Header>
<p>
Data does not exist for the selected date. The data being
displayed is for the last date selected.
</p>
</Message>
</div>
)}
{menuList}
<div className="modalwindow">
<div className="modalheader"style={{ color: colors.textcolor, textAlign: "left" }} >Information</div>
<div className="modalbox">Graph interpretation is different from map legend.
<ul>
<li
style={{ textAlign: "left", margin: "2px" }}
onClick={this.handleTechnicalNote}
>
<a style={{ textDecoration: "underline" }}>
Technical Note{" "}
</a></li>
<li
style={{ textAlign: "left", margin: "2px" }}
onClick={this.handleDisclaimer}
>
<a style={{ textDecoration: "underline" }}> Disclaimer</a>
</li> </ul></div>
</div>
</Sidebar>
<Sidebar.Pusher
dimmed={false}
style={{
height: "100%",
border: "0px",
background: "rgba(255,255,255,0.5)",
}}
>
<Segment
basic
style={{
width: "100%",
height: "100%",
padding: "0px",
border: "0px",
}}
>
<MapView
        nodata={this.state.nodata}
        emptyChartData={this.emptyChartData}
        popup={this.state.popup}
        addPopup={this.addPopup}
        SRSIPoint={this.state.SRSIPoint}
        srsibasinboundary={this.state.srsibasinboundary}
        srsireservoirboundary={this.state.srsireservoirboundary}
        swsibasinboundary={this.state.swsibasinboundary}
        swsisubbasinboundary={this.state.swsisubbasinboundary}
        selectedRegion={selectedRegion}
        selectedLayer={this.state.selectedLayer}
        visibleGraphPanel_pie={this.state.visibleGraphPanel_pie}
        toggleVisibleGraphPanel_pie={this.toggleVisibleGraphPanel_pie}
        toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
        setGradientContent={this.setGradientContent}
        sri_stats={this.state.sri_stats}
        pie_categories={this.state.pie_categories}
        displayLegend={this.displayLegend}
        legendVisible={this.state.legendVisible}
        legend={this.state.legend}
        setLegend={this.setLegend}
        setLatLng={this.setLatLng}
        latlng={this.state.latlng}
        markerPosition={[28.613, 77.209]}
        selected={this.state.selectedMenu}
        pointInfo={this.state.pointInfo}
        showInfo={this.state.showInfo}
        showPointInfo={this.showPointInfo}
        india_states_boundary={this.state.india_states_boundary}
        visibleLeft={this.state.visible}
        visibleGraphPanel={this.state.visibleGraphPanel}
        handleAnimationChange={this.handleAnimationChange}
        handleVisibleGraphPanelOnMapClick={
        this.handleVisibleGraphPanelOnMapClick
        }

        getFeatureInfo={this.getFeatureInfo}
        setStateInfo={this.setStateInfo}
        datesloading={this.state.datesloading}
        chartData={this.state.chartData}
        indiaHDBasinsselected={this.state.indiaHDBasinsselected}
        activeDate={
        moment.isMoment(this.state.date)
        ? this.state.date.format("DD-MMM-YYYY").toLowerCase()
        : moment(this.state.date, this.state.dateDisplayFormat)
        .format("DD-MMM-YYYY")
        .toLowerCase()
        }
        rchartData={this.state.rchartData}
        reservoirname={this.state.reservoirname}
        makeChartDataAvailableDays={this.makeChartDataAvailableDays}
        onClickDetails={{ ...this.state.onClickDetails }}
        setOnClickDetails={this.setOnClickDetails}
        chart
        stateInfo={
        this.state.stateInfo
        ? {
        key: this.state.stateInfo.id,
        geojson: { ...this.state.stateInfo },
        }
        : null
}

sliderOptions={{
onClickSlideLeft: this.onClickSlideLeft,
onClickSlideRight: this.onClickSlideRight,
onSlide: this.onSlide,
slideTracker: this.state.slideTracker,
max: this.state.availableDates.length - 1,
date: moment(
this.state.availableDates[this.state.slideTracker],
this.state.dateFormat
).format(this.state.sliderDateFormat),
}}
wms_url_base_layers={this.state.wms_url_base_layers}
stateBoundary={this.state.stateBoundary}
/>
</Segment>
{/*============================================================================================================================================================ */}
{/*============================================================================================================================================================ */}
{this.state.technicalnoteenable || this.state.disclaimerenable ? (
<Rnd
style={{ zIndex: "200", background: "white" }}
size={{ width: this.state.width, height: this.state.height }}
position={{ x: this.state.x, y: this.state.y }}
onDragStop={(e, d) => {
this.setState({ x: d.x, y: d.y });
}}
onResizeStop={(e, direction, ref, delta, position) => {
this.setState({
width: ref.style.width,
height: ref.style.height,
...position,
});
}}
>
{this.state.technicalnoteenable ? (
<div id="divDialog" class="dialog boxshadow">
<div class="dialog_header">
<div class="closebox" onClick={this.handleDialogClose}></div>
Technical Note </div>
<div id="divDialog" class="dialog boxshadow" style={{ overflowY: "auto" }}>
<div class="dialog_content">
<p align="justify"> <span style={{color:"blue"}}>Introduction:</span></p>
<p align="justify">Hydrological droughts can have widespread impacts by reducing or eliminating water supplies, deteriorating water quality, restricting water for irrigation and causing crop failure, reducing power generation, disturbing riparian habitats, limiting recreation activities, and affecting a diversity of economic and social activities. In contrast to climate droughts, the quantification of hydrological droughts is not usually on the basis of indexes, but on the theory of runs. Given the contrasting river regimes and flow magnitudes that can occur among neighboring basins, the spatial comparison of drought severity and the development of drought maps are impossible when using the method of runs. In vast and diverse countries like India, this would pose a problem while comparing the drought between the river basins. </p>
<p align="justify"> With the development in irrigation infrastructure facilities, water management practices, and increased human interventions in the water cycle, using one indicator doesn’t provide a holistic view of the existing hydrological drought conditions in a specific region. Hence a composite hydrological drought index made up of multiple independent indicators such as runoff, surface water spread, groundwater, and reservoir storages is required to give a full perspective of the actual severity and impact on the ground. The advantage of having multiple indicators is the composite index will be sensitive not just to a single indicator but multiple indicators, weighted, depending on the source of water in its local region. To combine all the indicators mentioned above, standardized indices from each of them have to be developed.</p>
<p align="justify">Hence as a part of the National Hydrology Project, it is envisaged to develop a composite hydrological drought index using standardized indices such as:</p>
<ul><li> Standardized Runoff Index (SRI)</li>
<li>Standardized Ground Water Inde(SGWI)</li>
<li>Standardized Reservoir Storage Index (SRSI)</li>
<li>Standardized Water Spread Index (SWSI)</li></ul>
<p align="justify">
<span style={{color:"blue"}}> Standardized Runoff Index (SRI):</span></p>
<p align="justify">
Many studies recently adopted the use of standardized indices, the approach commonly used for climate drought indexes, for characterizing hydrological drought. Standardized Runoff Index (SRI) is one such index where such an approach has been followed. Calculation of the SPI, which is a very commonly used climate drought index, is based on the gamma or the Pearson Type III distribution, whereas SPEI is based on the log‐logistic distribution. Streamflow and runoff commonly show greater spatial variability than climatic variables that are used to generate drought indices. This is because of the influence of a number of factors, including topography, lithology, vegetation, and human management, etc. Streamflow is channelized runoff and hence most of the factors affecting the streamflow affect Runoff too. India being a country with diverse landscapes, climatic conditions, land use, etc., fitting one distribution for an entire country or even an entire river basin is not appropriate. Hence the selection of best fitting distribution needs to be done in a region, based on the local runoff data. The most commonly used distributions were fitted to the SRI time-series data using the Maximum Likelihood Estimation (MLE) method.
</p>
<p align="justify"> <span style={{color:"blue"}}> Standardized Groundwater Index (SGWI):</span>
</p>
<p align="justify">
The estimation of the Standardised Groundwater Index (SGWI) is essentially built on the SPI approach prescribed by World Meteorological Organization (WMO, 2012). The SGWI calculation for any well location is based on the long-term groundwater level record for the desired period. Groundwater level data provided by the state groundwater department (GWD) of the Government of Telangana is used in this study.
</p>
<p align="justify">
<span style={{color:"blue"}}> Distribution Fitting:</span>
</p>
<p align="justify">
The distributions used in these indices are Gamma Distribution, Pearson Type-III, Normal, Log-Normal, Generalized Extreme Value Distribution, and Pareto Distribution. While fitting a distribution to the data, MLE estimates the parameters for a specific distribution that best explains the data. The distributions selected are then evaluated for the goodness of fit using the K-S test and the best distribution that fits the data is selected. Cunnane plotting position formula is used to calculate the probabilities of the sample in case the K-S test fails to provide the best fit within the regulated threshold. Once the best fit for the observations is obtained, the normal scores transformation, also known as z-scores transformation is applied to normalize the values and finalize the indices for individual grids/wells. To apply this transformation, unit normal standard deviates of p-values obtained from best-fitted distribution are calculated. The magnitude of the z-score can be classified into categories indicating the severity as suggested by World Meteorological Organization (WMO).
</p>
<p align="justify">
This SRI product depends on the runoff estimated from Variable Infiltration Capacity (VIC) which is a semi-distributed hydrological model. In the case of SGWI, groundwater well-wise z-score point data is converted to raster format using the IDW (Inverse Distance Weighted) interpolation.
</p>
<p align="justify">
<span style={{color:"blue"}}> References:</span></p>
<p align="justify">
<ul><li>Guttman, N.B., 1999. Accepting the standardized precipitation index: A calculation algorithm. J. Am. Water Resour. Assoc. 35, 311–322. https://doi.org/10.1111/j.1752-1688.1999.tb03592.x</li>
<li>Mckee, T.B., Doesken, N.J., Kleist, J., 1993. THE RELATIONSHIP OF DROUGHT FREQUENCY AND DURATION TO TIME SCALES, Eighth Conference on Applied Climatology.</li>
<li>Shukla, S., Wood, A.W., 2008. Use of a standardized runoff index for characterizing hydrologic drought. Geophys. Res. Lett. 35, 1–7. https://doi.org/10.1029/2007GL032487</li>
<li>Vicente-Serrano, S.M., 2006. Differences in spatial patterns of drought on different time scales: An analysis of the Iberian Peninsula. Water Resour. Manag. 20, 37–60. https://doi.org/10.1007/s11269-006-2974-8</li>
<li>Bhuiyan, C. (2004). Various Drought Indices for Monitoring Drought Condition in Aravalli Terrain, India. XXth ISPRS Conference. Istanbul: International Society of Photogrammetry and Remote Sensing.</li>
<li>Bloomfield, J. P., & Marchant, B. P. (2013, December 4). Analysis of groundwater drought building on the standardised precipitation index approach. Hydrology and Earth System Sciences, 17(12), 4769–4787.</li>
</ul>
</p>
<br/>
<br/>
</div>
</div>
</div>
) : this.state.disclaimerenable ? (
<div id="divDialog" class="dialog boxshadow">
<div class="dialog_header">
<div class="closebox" onClick={this.handleDialogDClose} ></div>
Disclaimer
</div>
<div
id="divDialog"
class="dialog boxshadow"
style={{ overflowY: "auto" }}
>
<div class="dialog_content">
<p align="justify">
The hydrological drought products are experimental. Product validation is to be carried out with appropriate historic data. The products quality depend on the input data accuracy. For more technical details, please write to nhp_nrsc@nrsc.gov.in </p>
<p align="justify">
NRSC uses several resources to derive and deliver these products through this website. Neither NRSC nor any other party involved in creating, producing or delivering the products through this website shall be liable for any direct, incidental, consequential, indirect or punitive damages arising out of users' access to, or use of, the website and the products. NRSC does not guarantee the accuracy of information provided by external sources and accepts no responsibility or liability for any consequences arising from the use of such data. No-data values inside India may be present due to non-availability of input data required to calculate the index. User feedback on any errors or inaccuracies is highly appreciated.
</p>
<br />
</div>
</div>
</div>
) : (
<div className="sweet-loading">
<FadeLoader
sizeUnit={"px"}
color={"#123abc"}
loading={this.state.chartloading}
/>
</div>
)}
</Rnd>
) : null}
{this.state.visibleGraphPanel ? (
<Rnd
style={{ zIndex: "200", background: "white" }}
size={{ width: this.state.width, height: this.state.height }}
position={{ x: this.state.x, y: this.state.y }}
onDragStop={(e, d) => {
this.setState({ x: d.x, y: d.y });
}}
onResizeStop={(e, direction, ref, delta, position) => {
this.setState({
width: ref.style.width,
height: ref.style.height,
...position,
});
}}
>


{this.state.rchartData !== null ? (
                  
                  <   Srsichart18dec
                      rname={this.state.reservoirname}
                      data={this.state.rchartData}
                      curr_date={this.state.reservoir_date}
                      srsi_chart={this.state.srsi_chart}
                      
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                  />
                ) : this.state.chartData !== null ? (
                 
                  <Chart
                    {...this.state.chartData}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                  />

               ) : (
                        <div className="sweet-loading">
                          <FadeLoader
                            // css={override}
                            sizeUnit={"px"}
                            // size={150}
                            color={"#123abc"}
                            loading={this.state.chartloading}
                          />
                        </div>
                      )}
                </Rnd>
              
            ) : null}
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

export default MapContainer;